module.exports = __webpack_public_path__ + "img/zz1.6834ca5e.jpg";